import { en } from './en';
import { fr } from './fr';

export const translations = {
  en,
  fr
};

// Hook personnalisé pour récupérer les traductions
export const getTranslation = (language) => {
  return translations[language] || translations.en;
};

export { en, fr };
